import {getAssetItem} from 'src/utils/helpers'

const FLUTE_SAMPLES = {
  A4: getAssetItem('audio/samples/flute/A4_small.mp3'),
  A5: getAssetItem('audio/samples/flute/A5_small.mp3'),
  A6: getAssetItem('audio/samples/flute/A6_small.mp3'),
  C4: getAssetItem('audio/samples/flute/C4_small.mp3'),
  C5: getAssetItem('audio/samples/flute/C5_small.mp3'),
  C6: getAssetItem('audio/samples/flute/C6_small.mp3'),
  C7: getAssetItem('audio/samples/flute/C7_small.mp3'),
  E4: getAssetItem('audio/samples/flute/E4_small.mp3'),
  E5: getAssetItem('audio/samples/flute/E5_small.mp3'),
  E6: getAssetItem('audio/samples/flute/E6_small.mp3'),
};

export {
  FLUTE_SAMPLES
}
